import React from 'react';
import { SubscriptionCard } from './SubscriptionCard';

interface UpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpgrade: () => void;
}

const UpgradeModal: React.FC<UpgradeModalProps> = ({ isOpen, onClose, onUpgrade }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[9999]">
      <div className="max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <SubscriptionCard
          showHeader
          onClose={onClose}
          onUpgrade={() => {
            onUpgrade();
          }}
          className="shadow-xl"
        />
      </div>
    </div>
  );
};

export default UpgradeModal;
